import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import { styles } from './styles';

const TableAppRow = ({
  children,
  onClick,
  classes,
  className,
  type,
  hover,
}) => {
  const componentClasses = classNames(
    { [className]: className },
    { [classes.tableHeadTr]: type === 'headerRow' },
  );

  const newProps = {};
  if (onClick) newProps.onClick = onClick;
  if (hover) newProps.hover = true;

  return (
    <TableRow {...newProps} className={componentClasses}>
      {children}
    </TableRow>
  );
};

export default withStyles(styles)(TableAppRow);



// WEBPACK FOOTER //
// ./src/components/IterioApp/components/TableApp/TableAppRow.jsx